(function(){
"use strict";

async function hofLoadAllSchools(cfg){
  const out=[]; let start=0; const pageSize=1000;
  while(start < 5000){
    const r=await fetch(cfg.url+"/rest/v1/fs_schools?select=id,name,short_name,slug,mascot,subdivision&active=eq.true&order=name.asc",{
      headers:{apikey:cfg.key||cfg.publishableKey,Range:start+"-"+(start+pageSize-1),"Range-Unit":"items"}
    });
    if(!r.ok) throw new Error(await r.text());
    const rows=await r.json(); out.push(...rows);
    if(rows.length < pageSize) break;
    start += pageSize;
  }
  const seen=new Set();
  return out.filter(s=>s && s.id && !seen.has(s.id) && seen.add(s.id));
}
function hofSchoolLabel(s){
  const bits=[s.name];
  if(s.mascot) bits.push(s.mascot);
  if(s.subdivision) bits.push(s.subdivision);
  return bits.join(" — ");
}
function hofPopulateSchoolSelect(select,schools,query,selectedId){
  const q=String(query||"").trim().toLowerCase();
  const filtered=q ? schools.filter(s=>{
    const hay=[s.name,s.short_name,s.slug,s.mascot,s.subdivision].filter(Boolean).join(" ").toLowerCase();
    return hay.includes(q);
  }) : schools;
  select.innerHTML='<option value="">Select a school</option>'+filtered.slice(0,500).map(s=>
    '<option value="'+s.id.replace(/"/g,"&quot;")+'"'+(s.id===selectedId?' selected':'')+'>'+hofSchoolLabel(s).replace(/</g,"&lt;").replace(/>/g,"&gt;")+'</option>'
  ).join("");
}

document.querySelectorAll("[data-hofcg-admin]").forEach(init);

function cfg(root){return{url:root.dataset.supabaseUrl,key:root.dataset.supabaseKey};}
function st(root,msg,kind){const e=root.querySelector("[data-admin-status]");if(!e)return;e.textContent=msg||"";e.dataset.kind=kind||"";}
function val(root,name){const e=root.querySelector('[name="'+name+'"]');return e?e.value:"";}
function num(root,name,f){const x=Number(val(root,name));return Number.isFinite(x)?x:f;}
async function auth(){const t=await window.HallOfFanCharacters.getAccessToken();if(!t)throw new Error("Sign in with a HallOfFan admin account first.");return t;}
async function call(root,body){const c=cfg(root),t=await auth();const r=await fetch(c.url+"/functions/v1/halloffan-character-admin",{method:"POST",headers:{apikey:c.key,Authorization:"Bearer "+t,"Content-Type":"application/json"},body:JSON.stringify(body)});const d=await r.json();if(!r.ok)throw new Error(d.error||"Admin request failed");return d;}
function mapObj(root,prefix){return{x:num(root,prefix+"_x",50),y:num(root,prefix+"_y",30),width:num(root,prefix+"_width",30),fontSize:num(root,prefix+"_size",14),rotation:num(root,prefix+"_rotation",0),color:val(root,prefix+"_color")||"#ffffff",fontFamily:"Arial Black, Arial, sans-serif"};}
function setPos(root,prefix,x,y){root.querySelector('[name="'+prefix+'_x"]').value=x.toFixed(1);root.querySelector('[name="'+prefix+'_y"]').value=y.toFixed(1);draw(root);}
function draw(root){
  const img=root.querySelector("[data-map-img]"),url=val(root,"blank_asset_url");
  if(url){img.src=url;img.hidden=false;} else {img.removeAttribute("src");img.hidden=true;}
  [["name","BROWN"],["number","12"]].forEach(([p,text])=>{const e=root.querySelector("[data-drag-"+p+"]"),m=mapObj(root,p);e.textContent=text;e.style.left=m.x+"%";e.style.top=m.y+"%";e.style.width=m.width+"%";e.style.fontSize=(m.fontSize/10)+"em";e.style.color=m.color;e.style.transform="translate(-50%,-50%) rotate("+m.rotation+"deg)";});
}
function makeDrag(root,el,prefix){
  el.addEventListener("pointerdown",ev=>{el.setPointerCapture(ev.pointerId);});
  el.addEventListener("pointermove",ev=>{if(!el.hasPointerCapture(ev.pointerId))return;const box=root.querySelector("[data-map-preview]").getBoundingClientRect();const x=Math.max(0,Math.min(100,(ev.clientX-box.left)/box.width*100));const y=Math.max(0,Math.min(100,(ev.clientY-box.top)/box.height*100));setPos(root,prefix,x,y);});
}
async function loadTemplates(root){
  const c=cfg(root),school=val(root,"school_id"),select=root.querySelector('[name="template_id"]');
  if(!school){select.innerHTML='<option value="">Select a school first</option>';return [];}
  select.innerHTML='<option value="">Loading templates…</option>';
  const r=await fetch(c.url+"/rest/v1/halloffan_character_templates?select=id,name,is_default,body_type,uniform_type,position_group&school_id=eq."+encodeURIComponent(school)+"&active=eq.true&order=is_default.desc,created_at.asc",{headers:{apikey:c.key}});
  if(!r.ok)throw new Error(await r.text());const rows=await r.json();
  select.innerHTML='<option value="">'+(rows.length?'Select template':'No templates yet — create one below')+'</option>'+rows.map(x=>'<option value="'+x.id+'">'+x.name+(x.is_default?' (default)':'')+'</option>').join("");
  return rows;
}
async function init(root){
  if(root.dataset.initialized==="1")return;root.dataset.initialized="1";
  const schoolSelect=root.querySelector('[name="school_id"]');
  const schoolSearch=root.querySelector("[data-school-search]");
  let schools=[];

  root.querySelectorAll("input").forEach(e=>e.addEventListener("input",()=>draw(root)));
  makeDrag(root,root.querySelector("[data-drag-name]"),"name");makeDrag(root,root.querySelector("[data-drag-number]"),"number");draw(root);

  try{
    st(root,"Loading schools…");
    schools=await hofLoadAllSchools(cfg(root));
    hofPopulateSchoolSelect(schoolSelect,schools,"","");
    const defaultSlug=String(root.dataset.defaultSchoolSlug||"").trim();
    if(defaultSlug){
      const match=schools.find(s=>s.slug===defaultSlug);
      if(match){schoolSelect.value=match.id;await loadTemplates(root);}
    }
    st(root,schools.length+" schools loaded. Select a school to begin.","success");
  }catch(e){st(root,"Could not load schools: "+(e.message||e),"error");}

  schoolSearch.addEventListener("input",()=>hofPopulateSchoolSelect(schoolSelect,schools,schoolSearch.value,schoolSelect.value));
  schoolSelect.addEventListener("change",async()=>{
    try{await loadTemplates(root);const s=schools.find(x=>x.id===schoolSelect.value);st(root,s?"Selected "+hofSchoolLabel(s):"Select a school.","success");}
    catch(e){st(root,e.message,"error");}
  });

  root.querySelector("[data-save-template]").addEventListener("click",async()=>{
    try{
      if(!val(root,"school_id"))throw new Error("Select a school first.");
      if(!val(root,"template_name").trim())throw new Error("Give the template a name.");
      st(root,"Saving template…");
      const d=await call(root,{action:"save_template",school_id:val(root,"school_id"),name:val(root,"template_name"),sport:val(root,"sport")||"football",body_type:val(root,"body_type")||"standard",uniform_type:val(root,"uniform_type")||"home",position_group:val(root,"position_group")||null,is_default:root.querySelector('[name="is_default"]').checked});
      await loadTemplates(root);root.querySelector('[name="template_id"]').value=d.template.id;
      st(root,"Template saved. Now choose artwork and create poses.","success");
    }catch(e){st(root,e.message,"error");}
  });

  root.querySelector("[data-use-shopify-image]").addEventListener("click",()=>{
    const url=String(root.dataset.shopifyImageUrl||"").trim();
    if(!url){st(root,"No Shopify Files image is selected. Open this section in Customize and choose one under “Shopify Files artwork”.","error");return;}
    root.querySelector('[name="blank_asset_url"]').value=url;draw(root);
    st(root,"Using the selected Shopify Files image. Position the name and number, then save the pose.","success");
  });

  root.querySelector("[data-upload]").addEventListener("click",async()=>{
    try{
      const file=root.querySelector('[name="blank_file"]').files[0];if(!file)throw new Error("Choose an image to upload first.");
      const template=val(root,"template_id");if(!val(root,"school_id"))throw new Error("Select a school first.");if(!template)throw new Error("Select or create a template first.");
      if(file.size>5*1024*1024)throw new Error("Artwork must be 5 MB or smaller.");
      st(root,"Uploading artwork…");
      const dataUrl=await new Promise((resolve,reject)=>{const fr=new FileReader();fr.onload=()=>resolve(fr.result);fr.onerror=reject;fr.readAsDataURL(file);});
      const d=await call(root,{action:"upload_blank_pose",school_id:val(root,"school_id"),template_id:template,pose_key:val(root,"pose_key")||"pose",mime_type:file.type||"image/png",file_base64:dataUrl});
      root.querySelector('[name="blank_asset_url"]').value=d.public_url;draw(root);st(root,"Artwork uploaded. Drag BROWN and 12 into position.","success");
    }catch(e){st(root,e.message,"error");}
  });

  root.querySelector("[data-save-pose]").addEventListener("click",async()=>{
    try{
      if(!val(root,"school_id"))throw new Error("Select a school first.");
      if(!val(root,"template_id"))throw new Error("Select a template first.");
      if(!val(root,"pose_key").trim())throw new Error("Enter a pose name/key, for example standing or throwing.");
      if(!val(root,"blank_asset_url"))throw new Error("Choose artwork from Shopify Files or upload an image first.");
      st(root,"Saving pose and queueing roster…");
      await call(root,{action:"save_pose",template_id:val(root,"template_id"),pose_key:val(root,"pose_key"),pose_name:val(root,"pose_name")||val(root,"pose_key"),blank_asset_url:val(root,"blank_asset_url"),name_map:mapObj(root,"name"),number_map:mapObj(root,"number")});
      st(root,"Pose saved. Existing characters using this template are queued automatically.","success");
    }catch(e){st(root,e.message,"error");}
  });

  root.querySelector("[data-backfill]").addEventListener("click",async()=>{
    try{if(!val(root,"school_id"))throw new Error("Select a school first.");st(root,"Syncing roster…");const d=await call(root,{action:"backfill_school",school_id:val(root,"school_id")});st(root,(d.athletes_synced||0)+" roster athletes synced to Character Generator.","success");}catch(e){st(root,e.message,"error");}
  });

  root.querySelector("[data-process]").addEventListener("click",async()=>{
    try{let total=0,remaining=1;st(root,"Generating queued characters…");while(remaining>0 && total<250){const d=await call(root,{action:"process_queue",limit:25});total+=d.processed||0;remaining=d.remaining||0;st(root,total+" renders processed; "+remaining+" remaining…");if((d.processed||0)===0)break;}st(root,total+" renders processed. "+remaining+" remaining.","success");}catch(e){st(root,e.message,"error");}
  });
}
})();
